// React
import { useEffect, useState } from "react";
// import axios from "axios";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";

import ModalEdit from "layouts/lessons/others/modalEdit";
import DeleteDialog from "layouts/lessons/others/modalDelete";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import QuizIcon from "@mui/icons-material/Quiz";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "examples/Tables/DataTable";
import {
  Avatar,
  CircularProgress,
  Dialog,
  DialogTitle,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from "@mui/material";

import Stack from "@mui/material/Stack";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";

// json web token
// eslint-disable-next-line camelcase
import jwt_decode from "jwt-decode";

// Services
import { statusData } from "constants/utils/lesson/formdata";
import { update } from "services/lesson/lessons.services";

import Paragraphs from "../paragraphs";
import Quizzes from "../quizzes";

function formatDate(date) {
  const today = date.split("-");
  const dd = today[0];

  const mm = parseInt(today[1], 10) - 1;
  const yyyy = today[2];

  return new Date(yyyy, mm, dd);
}

function Author({ name, tel }) {
  return (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{tel}</MDTypography>
      </MDBox>
    </MDBox>
  );
}

const columns = [
  { Header: "Titre", accessor: "title", align: "left" },
  { Header: "Resumée", accessor: "resume", width: "25%", align: "left" },
  { Header: "Auteurs", accessor: "authors", width: "25%", align: "left" },
  { Header: "Status", accessor: "status", align: "center" },
  { Header: "Accès", accessor: "access", align: "center" },
  { Header: "Date de création", accessor: "createdAt", align: "center" },
  { Header: "Dernière modification", accessor: "updatedAt", align: "center" },
  { Header: "action", accessor: "action", align: "center" },
];
const dataAccess = [
  { id: 1, value: "Gratuit" },
  { id: 2, value: "Payant" },
];

function lessonsData() {
  const courses = useSelector((state) => state.course.allCourses);
  const users = useSelector((state) => state.user.allUsers);
  const [authorList, setAuthorList] = useState([]);
  const lessons = useSelector((state) => state.lesson.allLessons);
  const [currentLesson, setCurrentLesson] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatchApi = useDispatch();
  const [dataAfterSearch, setDataAfterSearch] = useState([]);

  const [fields, setFields] = useState({
    access: { value: "Aucune" },
    course: { value: "Aucune" },
    user: { value: "Aucune" },
    titleORresume: { value: "" },
    dateDebut: { value: null },
    dateFin: { value: null },
  });
  const filterAuthor = () => {
    let utilisator = users;
    utilisator = utilisator.filter((u) => u.roles.includes("ROLE_AUTHOR"));
    return utilisator;
  };

  useEffect(() => {
    setAuthorList(filterAuthor());
  }, [users]);

  const resetSearch = () => {
    setFields({
      access: { value: "Aucune" },
      course: { value: "Aucune" },
      user: { value: "Aucune" },
      titleORresume: { value: "" },
      dateDebut: { value: null },
      dateFin: { value: null },
    });
    setDataAfterSearch(lessons);
  };
  const filterData = (accessParam, courseParam, userParam, titleORresume, dateDebut, dateFin) => {
    let data = lessons;

    if (accessParam !== "Aucune")
      data = data.filter((l) => (accessParam === "Gratuit" ? l.price === 0 : l.price > 0));
    if (courseParam !== "Aucune") data = data.filter((l) => l.course.wording.includes(courseParam));
    if (userParam !== "Aucune")
      data = data.filter((l) => l.users.some((user) => user.fullname.includes(userParam)));
    if (titleORresume !== "")
      data = data.filter(
        (l) =>
          l.title.toLowerCase().includes(titleORresume.toLowerCase()) ||
          l.resume.toLowerCase().includes(titleORresume.toLowerCase())
      );
    if (dateDebut !== null) data = data.filter((l) => dateDebut <= formatDate(l.createdAt));
    if (dateFin !== null) data = data.filter((l) => formatDate(l.createdAt) <= dateFin);

    return data;
  };

  useEffect(() => {
    setDataAfterSearch(
      filterData(
        fields.access.value,
        fields.course.value,
        fields.user.value,
        fields.titleORresume.value,
        fields.dateDebut.value,
        fields.dateFin.value
      )
    );
  }, [lessons]);

  const handleChangeSearch = (name, value) => {
    setFields((f) => ({
      ...f,
      [name]: { value },
    }));
    setDataAfterSearch(
      filterData(
        name === "access" ? value : fields.access.value,
        name === "course" ? value : fields.course.value,
        name === "user" ? value : fields.user.value,
        name === "titleORresume" ? value : fields.titleORresume.value,
        name === "dateDebut" ? value : fields.dateDebut.value,
        name === "dateFin" ? value : fields.dateFin.value
      )
    );

    if (
      (name === "access" ? value : fields.access.value) === "Aucune" &&
      (name === "course" ? value : fields.course.value) === "Aucune" &&
      (name === "user" ? value : fields.user.value) === "Aucune" &&
      (name === "titleORresume" ? value : fields.titleORresume.value) === "" &&
      (name === "dateDebut" ? value : fields.dateDebut.value) === null &&
      (name === "dateFin" ? value : fields.dateFin.value) === null
    )
      setDataAfterSearch(lessons);
  };
  const isAdmin =
    localStorage.getItem("token") &&
    jwt_decode(localStorage.getItem("token")).roles.includes("ROLE_ADMIN");

  const handleClose = () => {
    setOpen(false);
  };

  const finished = () => {
    handleClose();
    setDialog(null);
    setCurrentLesson(null);
  };

  const rows = dataAfterSearch.map((lesson) => ({
    title: (
      <div key={lesson.title} style={{ maxWidth: 150 }}>
        <MDTypography
          sx={{ cursor: "pointer" }}
          onClick={(e) => {
            e.preventDefault();
            setOpen(true);
            setCurrentLesson(lesson);
          }}
          variant="caption"
          color="text"
          fontWeight="medium"
        >
          {lesson.title}
        </MDTypography>
      </div>
    ),
    resume: (
      <div style={{ maxWidth: 200 }}>
        <MDTypography variant="caption" color="text" fontWeight="medium">
          {lesson.resume}
        </MDTypography>
      </div>
    ),
    authors: lesson.users.map((auteur) => (
      <Author key={auteur.id} name={auteur.fullname} tel={auteur.tel} />
    )),
    status: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={lesson.status}
          color={
            // eslint-disable-next-line no-nested-ternary
            lesson.status === "Validé"
              ? "success"
              : lesson.status !== "Archivé"
              ? "primary"
              : "secondary"
          }
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    access: (
      <MDBox ml={-1}>
        <MDBadge
          badgeContent={lesson.price > 0 ? "payant" : "gratuit"}
          color={
            // eslint-disable-next-line no-nested-ternary
            lesson.price > 0 ? "success" : "secondary"
          }
          variant="gradient"
          size="sm"
        />
      </MDBox>
    ),
    createdAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {lesson.createdAt}
      </MDTypography>
    ),
    updatedAt: (
      <MDTypography variant="caption" color="text" fontWeight="medium">
        {lesson.updatedAt}
      </MDTypography>
    ),
    action: (
      <MDBox component="div" sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        {isAdmin && lesson.status === "A valider" && (
          <MDTypography
            mx={1}
            sx={{ cursor: "pointer" }}
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={async () => {
              setLoading(true);
              await update(statusData({ id: lesson.id, status: "Validé" })).then(({ data }) =>
                dispatchApi({ type: "UPDATED_LESSON", data })
              );
              setLoading(false);
            }}
          >
            Valider
          </MDTypography>
        )}
        {lesson.status !== "Archivé" && (
          <MDTypography
            mx={1}
            sx={{ cursor: "pointer" }}
            variant="caption"
            color="text"
            fontWeight="medium"
            onClick={async () => {
              setLoading(true);
              await update(statusData({ id: lesson.id, status: "Archivé" })).then(({ data }) =>
                dispatchApi({ type: "UPDATED_LESSON", data })
              );
              setLoading(false);
            }}
          >
            Archiver
          </MDTypography>
        )}
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentLesson(lesson);
            setDialog("edit");
          }}
        >
          Editer
        </MDTypography>
        <MDTypography
          mx={1}
          sx={{ cursor: "pointer" }}
          variant="caption"
          color="text"
          fontWeight="medium"
          onClick={() => {
            setCurrentLesson(lesson);
            setDialog("remove");
          }}
        >
          Supprimer
        </MDTypography>
      </MDBox>
    ),
  }));
  return (
    <>
      {loading && (
        <CircularProgress size="10em" color="info" sx={{ position: "fixed", left: "35%" }} />
      )}
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>Choisir: </DialogTitle>
        <List sx={{ p: 1 }}>
          <ListItem
            sx={{ pb: 1 }}
            autoFocus
            button
            onClick={() => {
              dispatchApi({ type: "FETCHED_PARAGRAPH", data: currentLesson.paragraphs });
              setDialog("paragraphs");
            }}
          >
            <ListItemAvatar>
              <Avatar>
                <FormatListBulletedIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Paragraphes" />
          </ListItem>

          <ListItem
            autoFocus
            button
            onClick={() => {
              dispatchApi({ type: "FETCHED_QUIZ", data: currentLesson.quizzes });
              setDialog("quizzes");
            }}
          >
            <ListItemAvatar>
              <Avatar>
                <QuizIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary="Quiz" />
          </ListItem>
        </List>
      </Dialog>

      <MDBox
        sx={{
          // display: "flex",
          // justifyContent: "flex-end",
          p: 1,
          m: 1,
        }}
      >
        <Stack
          // alignItems="center"
          justifyContent="center"
          direction={{ xs: "column", md: "row" }}
          spacing={1}
        >
          <div>
            <FormControl sx={{ m: 1, minWidth: 60 }} fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">
                Filtrer par accès
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-Catégorie"
                id="demo-simple-select-Catégorie"
                name="access"
                value={fields.access.value}
                label="Filtrer par accès"
                onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              >
                <MenuItem value="Aucune">Aucune</MenuItem>
                {dataAccess.map((ac) => (
                  <MenuItem key={ac.id} value={ac.value}>
                    {ac.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <FormControl sx={{ m: 1, minWidth: 140 }} fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">
                Filtrer par Cours
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-Catégorie"
                id="demo-simple-select-Catégorie"
                name="course"
                value={fields.course.value}
                label="Filtrer par Cours"
                onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              >
                <MenuItem value="Aucune">Aucune</MenuItem>
                {courses.map((cr) => (
                  <MenuItem key={cr.id} value={cr.wording}>
                    {cr.wording}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div>
            <FormControl sx={{ m: 1, minWidth: 140 }} fullWidth>
              <InputLabel size="small" id="demo-simple-select-label">
                Filtrer par auteur
              </InputLabel>
              <Select
                labelId="demo-simple-select-label-auteur"
                id="demo-simple-select-auteur"
                name="user"
                value={fields.user.value}
                label="Filtrer par auteur"
                onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              >
                <MenuItem value="Aucune">Aucune</MenuItem>
                {authorList.map((user) => (
                  <MenuItem key={user.fullname} value={user.fullname}>
                    {user.fullname}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={1} sx={{ width: "100%", ml: 1, my: 1 }} direction="row">
                <DesktopDatePicker
                  label="Date début"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateDebut.value}
                  onChange={(e) => handleChangeSearch("dateDebut", e)}
                  renderInput={(params) => (
                    <TextField
                      style={{ width: "inherit" }}
                      // onChange={(e) => {
                      //   if (e.target.value === "") setDataAfterSearch(lessons);
                      // }}
                      {...params}
                    />
                  )}
                />
                <DesktopDatePicker
                  label="Date fin"
                  inputFormat="dd/MM/yyyy"
                  value={fields.dateFin.value}
                  onChange={(e) => handleChangeSearch("dateFin", e)}
                  renderInput={(params) => (
                    <TextField
                      style={{ width: "inherit" }}
                      // onChange={(e) => {
                      //   if (e.target.value === "") setDataAfterSearch(lessons);
                      // }}
                      {...params}
                    />
                  )}
                />
              </Stack>
            </LocalizationProvider>
          </div>

          <div style={{ display: "inline-flex", alignItems: "center" }}>
            <TextField
              name="titleORresume"
              value={fields.titleORresume.value}
              sx={{ ml: 1, my: 1, minWidth: 140 }}
              onChange={(e) => handleChangeSearch(e.target.name, e.target.value)}
              label="Titre ou résumée"
              id="outlined-size-small"
              fullWidth
            />
            <RestartAltIcon sx={{ m: 1 }} onClick={() => resetSearch()} />
          </div>
        </Stack>
      </MDBox>
      <DataTable
        table={{ columns, rows }}
        isSorted={false}
        entriesPerPage={false}
        showTotalEntries={false}
        noEndBorder
      />
      {dialog === "edit" && <ModalEdit lesson={currentLesson} finished={finished} />}
      {dialog === "remove" && <DeleteDialog lessonId={currentLesson.id} finished={finished} />}

      {dialog === "paragraphs" && <Paragraphs lesson={currentLesson} finished={finished} />}
      {dialog === "quizzes" && <Quizzes lesson={currentLesson} finished={finished} />}
    </>
  );
}

Author.propTypes = {
  name: PropTypes.string.isRequired,
  tel: PropTypes.string.isRequired,
};

export default lessonsData;
